'use strict';

angular
  .module('kerp-forms.forms')
  .factory('SSCS1_FORM', ['FormUI', function (FormUI) {
    var formUI = new FormUI();

    var form = [
      {
        type: 'section',
        condition: 'model.page === 1',
        page: 1,
        items: [
          {
            type: 'help',
            htmlClass: 'well',
            helpvalue: '<div><h2>Notice of appeal against a decision of the Department for Work and Pensions</h2><p>You should use this form to appeal against a decision made by the Department for Work and Pensions (DWP) about social security benefits. For decisions regarding child support or child maintenance, you should use form <a href="https://assets.publishing.service.gov.uk/government/uploads/system/uploads/attachment_data/file/975082/sscs2-eng.pdf" target="_blank">SSCS2</a>. For appeals regarding recovery of compensation you should use form <a href="https://assets.publishing.service.gov.uk/government/uploads/system/uploads/attachment_data/file/772405/sscs3-eng.pdf" target="_blank">SSCS3</a>.</p><p>Further guidance to help you fill in this form is available in booklet <a href="https://www.gov.uk/government/publications/how-to-appeal-a-decision-by-dwp-sscs1a" target="_blank">SSCS1A</a> ‘How to appeal against a decision made by the Department for Work and Pensions’.</p><h3>About this form</h3><p>This form helps you provide all the information the tribunal requires to register your appeal. It will also ensure that your appeal contains all the necessary details which the law requires.</p><h3>How to fill in this form</h3><p><strong>You must complete Sections 1, 2, 5, 6 and 8</strong></p><p>If you want to <strong>attend a hearing</strong>, you must also <strong>complete Section 7</strong></p><p>If you are appealing on <strong>behalf of someone who a court or DWP has appointed you to act for</strong>, you must also <strong>complete Section 3</strong></p><p>If you have <strong>a representative</strong>, you must also <strong>complete Section 4</strong></p><h3>What to include with this form</h3><p>You <strong>must</strong> include a copy of the <strong>mandatory reconsideration notice</strong> which shows the decision you are appealing against. You do not need to include evidence/information you have already sent to DWP as they will send it to us as part of their response.</p></div>'
          },
          {
            type: 'help',
            helpvalue: '<div><h2 class=\'formPartTitle\'>Section 1: About the decision you are appealing</h2></div>'
          },
          {
            type: 'help',
            htmlClass: 'well',
            helpvalue: '<div>This section is about your mandatory reconsideration notice. This is the letter sent to you by DWP explaining that they have looked at your decision again.</div>'
          },
          {
            key: 'Check_Box1',
            title: 'Does your mandatory reconsideration notice tell you that you have the right to appeal against the decision?',
            type: 'radios',
            titleMap: [{
              value: 'no',
              name: 'No'
            },
              {
                value: 'Yes',
                name: 'Yes'
              }],
            style: {selected: 'btn-primary', unselected: 'btn-default'},
            description: 'If No, please ensure you have read the section ‘Can I Appeal?’ in the booklet <a href="https://www.gov.uk/government/publications/how-to-appeal-a-decision-by-dwp-sscs1a" target="_blank">SSCS1A</a> ‘How to appeal against a decision made by the Department for Work and Pensions’ before continuing with this form.'
          },
          {
            key: 'Check_Box2',
            title: 'Please tick "Yes" to confirm that you have attached a copy of the mandatory reconsideration notice with your appeal form.',
            type: 'radios',
            titleMap: [{value: 'no', name: 'No'},
              {value: 'Yes', name: 'Yes'}
            ]
          },
          {
            key: 'Text15',
            title: 'Please provide the name of the benefit your appeal relates to. The name of the benefit will be shown on the letter giving you the decision.',
            type: 'textarea',
            description: 'Remember to include a copy of your mandatory reconsideration notice with your appeal form. If you do not do so, we will be unable to register your appeal until this is provided.'
          }
        ]
      },
      {
        type: 'section',
        condition: 'model.page === 2',
        page: 2,
        items: [
          {
            type: 'help',
            helpvalue: '<div><h2 class=\'formPartTitle\'>Section 2: About you</h2></div>'
          },
          {
            type: 'help',
            htmlClass: 'well',
            helpvalue: '<div>Fill in this section if the decision you are appealing against is about your benefit or the benefit of a person you have been appointed by DWP or a court to take care of. If you are appointed by DWP or a court to take charge of another person’s benefit, you should also record their details in Section 3.</div>'
          },
          {
            key: 'Check_Box3',
            type: 'radios',
            title: 'Title',
            "titleMap": [
              {"value": "mr", "name": "Mr"},
              {"value": "mrs", "name": "Mrs"},
              {"value": "miss", "name": "Miss"},
              {"value": "ms", "name": "Ms"}
            ]
          },
          {
            key: 'Text4',
            title: 'Other title (please specify)'
          },
          {
            key: 'Text5',
            title: 'First name(s)'
          },
          {
            key: 'Text6',
            title: 'Surname'
          },
          {
            key: 'Text7',
            title: 'Address',
            type: 'textarea'
          },
          {
            type: 'help',
            htmlClass: 'helpTitle',
            helpvalue: '<div>Postcode</div>'
          },
          {
            type: "section",
            htmlClass: "row",
            items: [
              {
                type: "section",
                htmlClass: "col-xs-6 col-sm-3",
                items: [{
                  key: "Text8",
                  notitle: true,
                  placeholder: 'Characters before space',
                  errorLabel: 'Postcode characters before space'
                }]
              },
              {
                type: "section",
                htmlClass: "col-xs-6 col-sm-3",
                items: [{
                  key: "Text1",
                  notitle: true,
                  placeholder: '3 characters after space',
                  errorLabel: 'Postcode characters after space'
                }]
              }
            ]
          },
          {
            key: 'Text13',
            title: 'Daytime phone number'
          },
          {
            key: 'Text14',
            title: 'Mobile phone number'
          },
          {
            key: 'Text9',
            type: 'memorabledate',
            title: 'Date of birth',
            validationMessage: 'The date of birth is incorrect',
            maxDate: new Date(),
            dateFormat: 'DDMMYYYY',
            required: true
          },
          {
            type: "help",
            htmlClass: 'helpTitle',
            helpvalue: '<div>National Insurance number</div>'

          },
          {
            type: "section",
            htmlClass: "row",
            items: [
              {
                type: "section",
                htmlClass: "col-xs-3 col-md-2",
                items: [{
                  key: "Text10",
                  notitle: true,
                  errorLabel: 'First 2 letter of national insurance number'
                }]
              },
              {
                type: "section",
                htmlClass: "col-xs-6 col-md-5",
                items: [{
                  key: "Text11",
                  notitle: true,
                  errorLabel: '6 digits of national insurance number'
                }]
              },
              {
                type: "section",
                htmlClass: "col-xs-3 col-md-2",
                items: [{
                  key: "Text12",
                  notitle: true,
                  errorLabel: 'Last letter of national insurance number'
                }]
              }
            ]
          },
          {
            type: "help",
            htmlClass: 'alert alert-success',
            helpvalue: '<div>If you are appealing on behalf of a child or other person and you have provided their National Insurance number in Section 3, you do not need to provide your own National Insurance number.</div>'
          }
        ]
      },
      {
        type: 'section',
        condition: 'model.page === 3',
        page: 3,
        items: [
          {
            type: 'help',
            helpvalue: '<div><h2 class=\'formPartTitle\'>Section 3: About a child or other person you are appealing for</h2></div>'
          },
          {
            type: 'help',
            htmlClass: 'well',
            helpvalue: '<div>This section is for people who are making an appeal on behalf of someone they have a legal responsibility for. This might be a parent acting for a child or a person who has been appointed by DWP or a court to look after the affairs of another adult.</div>'
          },
          {
            key: 'Check_Box15',
            title: 'Are you appealing on behalf of a child or other person whose affairs you have been appointed to take care of?',
            type: 'radios',
            titleMap: [{value: 'no', name: 'No'},
              {value: 'Yes', name: 'Yes'}
            ]
          },
          {
            type: 'section',
            condition: 'model["Check_Box15"] === "Yes"',
            items: [
              {
                key: 'Check_Box16',
                type: 'radios',
                title: 'Title',
                "titleMap": [
                  {"value": "mr", "name": "Mr"},
                  {"value": "mrs", "name": "Mrs"},
                  {"value": "miss", "name": "Miss"},
                  {"value": "ms", "name": "Ms"}
                ]
              },
              {
                key: 'Text17',
                title: 'Other title (please specify)'
              },
              {
                key: 'Text18',
                title: 'First name(s)'
              },
              {
                key: 'Text19',
                title: 'Surname'
              },
              {
                key: 'Text20',
                title: 'Address',
                type: 'textarea'
              },
              {
                type: 'help',
                htmlClass: 'helpTitle',
                helpvalue: '<div>Postcode</div>'
              },
              {
                type: "section",
                htmlClass: "row",
                items: [
                  {
                    type: "section",
                    htmlClass: "col-xs-6 col-sm-4",
                    items: [{
                      key: "Text21",
                      notitle: true,
                      placeholder: 'Characters before space'
                    }]
                  },
                  {
                    type: "section",
                    htmlClass: "col-xs-6 col-sm-4",
                    items: [{
                      key: "Text2",
                      notitle: true,
                      placeholder: '3 characters after space'
                    }]
                  }
                ]
              },
              {
                key: 'Text22',
                type: 'memorabledate',
                title: "Child's date of birth",
                validationMessage: 'The date of birth is incorrect',
                dateFormat: 'DDMMYYYY',
                required: true,
                maxDate: new Date()
              },
              {
                type: "help",
                htmlClass: 'helpTitle',
                helpvalue: '<div>National Insurance number</div>'

              },
              {
                type: "section",
                htmlClass: "row",
                items: [
                  {
                    type: "section",
                    htmlClass: "col-xs-3 col-md-2",
                    items: [{
                      key: "Text23",
                      notitle: true
                    }]
                  },
                  {
                    type: "section",
                    htmlClass: "col-xs-6 col-md-5",
                    items: [{
                      key: "Text24",
                      notitle: true
                    }]
                  },
                  {
                    type: "section",
                    htmlClass: "col-xs-3 col-md-2",
                    items: [{
                      key: "Text25",
                      notitle: true
                    }]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        type: 'section',
        condition: 'model.page === 4',
        page: 4,
        items: [
          {
            type: 'help',
            helpvalue: '<div><h2 class=\'formPartTitle\'>Section 4: About your representative (If you have one)</h2></div>'
          },
          {
            type: 'help',
            htmlClass: 'well',
            helpvalue: '<div>This section is about your representative (if you have one). By representative we mean someone acting on your behalf in a formal capacity. This might be an organisation like Citizens Advice or a welfare rights service or it may be a friend or advisor who knows about social security matters. If you name a representative here and give your signature at Section 8, this will authorise us to deal with your representative about your appeal. If you are unsure about this, please read the section ‘About Your Representative’ in the guidance booklet <a href="https://www.gov.uk/government/publications/how-to-appeal-a-decision-by-dwp-sscs1a" target="_blank">SSCS1A</a>.</div>'
          },
          {
            key: 'Check_Box26',
            title: 'Do you have a representative?',
            type: 'radios',
            titleMap: [{value: 'no', name: 'No'},
              {value: 'Yes', name: 'Yes'}
            ]
          },
          {
            type: 'section',
            condition: 'model["Check_Box26"] === "Yes"',
            items: [
              {
                key: 'Text27',
                title: 'Name of organisation or of person representing'
              },
              {
                key: 'Text28',
                title: 'Phone number'
              },
              {
                key: 'Text29',
                title: 'Address',
                type: 'textarea'
              },
              {
                type: 'help',
                htmlClass: 'helpTitle',
                helpvalue: '<div>Postcode</div>'
              },
              {
                type: "section",
                htmlClass: "row",
                items: [
                  {
                    type: "section",
                    htmlClass: "col-xs-6 col-sm-4",
                    items: [{
                      key: "Text30",
                      notitle: true,
                      placeholder: 'Characters before space'
                    }]
                  },
                  {
                    type: "section",
                    htmlClass: "col-xs-6 col-sm-4",
                    items: [{
                      key: "Text3",
                      notitle: true,
                      placeholder: '3 characters after space'
                    }]
                  }
                ]
              },
              {
                key: 'Check_Box31',
                type: 'radios',
                title: 'Title',
                "titleMap": [
                  {"value": "mr", "name": "Mr"},
                  {"value": "mrs", "name": "Mrs"},
                  {"value": "miss", "name": "Miss"},
                  {"value": "ms", "name": "Ms"}
                ]
              },
              {
                key: 'Text32',
                title: 'Other title (please specify)'
              },
              {
                key: 'Text33',
                title: 'First name'
              },
              {
                key: 'Text34',
                title: 'Surname'
              }
            ]
          }
        ]
      },
      {
        type: 'section',
        condition: 'model.page === 5',
        page: 5,
        items: [
          {
            type: 'help',
            helpvalue: '<div><h2 class=\'formPartTitle\'>Section 5: About your appeal</h2></div>'
          },
          {
            type: 'help',
            htmlClass: 'well',
            helpvalue: '<div><h4>Grounds for appeal</h4><p>In this section we need to know why you are appealing. Please explain in your own words the reasons why you disagree with DWP’s decision. If you do not complete this section this will delay dealing with your appeal and the appeal form may be returned to you. For more information on grounds for appeal please refer to the ‘About Your Appeal’ section of the guidance booklet <a href="https://www.gov.uk/government/publications/how-to-appeal-a-decision-by-dwp-sscs1a" target="_blank">SSCS1A</a>.</p></div>'
          },
          {
            key: 'Text35',
            type: 'textarea',
            title: 'Why do you disagree with DWP’s decision?'
          },
          {
            type: 'help',
            htmlClass: 'well',
            helpvalue: '<div><h4>Is your appeal in time?</h4><p>According to the law, your appeal must be received by the tribunal no later than one calendar month after the date the mandatory reconsideration notice was sent to you. If your appeal is received after this date, it is a late appeal and the tribunal will need to know why it is late.</p></div>'
          },
          {
            key: 'Check_Box36',
            title: 'Is your appeal late?',
            type: 'radios',
            titleMap: [{value: 'no', name: 'No'},
              {value: 'Yes', name: 'Yes'}
            ],
            description: 'According to the law, your appeal must be received by the tribunal no later than one calendar month after the date the mandatory reconsideration notice was sent to you. If your appeal is received after this date, it is a late appeal and the tribunal will need to know why it is late.'
          },
          {
            type: 'section',
            condition: 'model["Check_Box36"] === "Yes"',
            items: [
              {
                type: 'help',
                htmlClass: 'well',
                helpvalue: '<div>If your appeal is late, you must give an explanation why. The tribunal will consider your reasons and can extend the time limit for you. If you do not give reasons why your appeal is late your appeal form may be sent back to you. Please tell us below why your appeal is late. </div>'
              },
              {
                key: 'Text37',
                type: 'textarea',
                title: 'Why is your appeal late?',
                description: 'The Department for Work and Pensions has the right to object to a late appeal. The tribunal will consider any objection they make and they will let you know the outcome.'
              }
            ]
          }
        ]
      },
      {
        type: 'section',
        condition: 'model.page === 6',
        page: 6,
        items: [
          {
            type: 'template',
            template: '<div><h2 class=\'formPartTitle\'>Section 6: About your choice of hearing</h2><p><a href=" https://www.youtube.com/watch?v=7Q1K7SXQuBY" title="SSCS1: Appeals Hearings">Watch this video for advice on appeals hearings.</a></p></div>'
          },
          {
            type: 'template',
            htmlClass: 'well',
            template: '<div><p>Appeals are considered by an independent panel. We will make arrangements for your appeal to be heard by the panel and you or your representative will be expected to attend the hearing. If, however, you do not wish to attend a hearing you can ask for your appeal to be decided on the papers. Please tell us below how you would like us to deal with your appeal</p><p><a href="https://www.youtube.com/watch?v=lOZ35pua5WA" title="SSCS1: Appeals papers">Watch this video to find out what to do when you receive your appeal papers.</a></p></div>'
          },
          {
            key: 'Check_Box38',
            title: 'Do you want to attend a hearing of your appeal?',
            type: 'radios',
            titleMap: [{value: 'no', name: 'No'},
              {value: 'Yes', name: 'Yes'}
            ],
            description: '<p>If you select No, your case will be decided on papers.</p>If you change your mind about this, you must tell us as soon as possible as it may be too late to change this once the hearing has been arranged. For more information, please refer to the ‘About Your Choice of Hearing’ section in the guidance booklet <a href="https://www.gov.uk/government/publications/how-to-appeal-a-decision-by-dwp-sscs1a" target="_blank">SSCS1A</a>.'
          }
        ]
      },
      {
        type: 'section',
        condition: 'model.page === 7',
        page: 7,
        items: [
          {
            type: 'help',
            helpvalue: '<div><h2 class=\'formPartTitle\'>Section 7: The hearing — Your needs and requirements</h2></div>'
          },
          {
            type: 'help',
            htmlClass: 'well',
            helpvalue: '<div><p>In this section we need to ask you a number of questions to help us arrange a suitable hearing for you. We will try to accommodate your needs and availability, but it may not always be possible to do this. Please answer all the questions below to give us the information we require. If you do not answer some of the questions we will have to contact you again and this may delay your appeal.</p></div>'
          },
          {
            key: 'Check_Box39',
            condition: 'model["Check_Box38"] !== "no"',
            title: 'Are you available to attend a hearing at any time?',
            type: 'radios',
            titleMap: [{value: 'no', name: 'No'},
              {value: 'Yes', name: 'Yes'}
            ],
            description: 'Tribunal hearings are held Monday to Friday from 10am to 5pm and in our larger hearing centres also on Saturday. To allow you to attend your hearing, we will try to arrange a time and date in line with your availability. It is important that you tell us here if there are any days of the week or times of the day when you cannot attend a tribunal or any dates when you are unavailable because of things like booked holidays and hospital appointments. You should consider your availability for the six months ahead.'
          },
          {
            type: 'section',
            condition: 'model["Check_Box39"] === "no"',
            items: [
              {
                key: 'Text40',
                type: 'textarea',
                title: 'Please tell us when you cannot attend in this box below'
              }
            ]
          },
          {
            key: 'Check_Box41',
            condition: 'model["Check_Box38"] !== "no"',
            title: 'Do you have special needs?',
            type: 'radios',
            titleMap: [{value: 'no', name: 'No'},
              {value: 'Yes', name: 'Yes'}
            ],
            description: 'Please tell us here about any special needs you may have which we need to take into account when arranging your hearing. This might be things such as hearing loops or disability access.'
          },
          {
            type: 'section',
            condition: 'model["Check_Box41"] === "Yes"',
            items: [
              {
                key: 'Text42',
                type: 'textarea',
                title: 'Please tell us about them in this box below'
              }
            ]
          },
          {
            key: 'Check_Box43',
            condition: 'model["Check_Box38"] !== "no"',
            title: 'Do you require an interpreter or signer to assist you at the hearing?',
            type: 'radios',
            titleMap: [{value: 'no', name: 'No'},
              {value: 'Yes', name: 'Yes'}
            ],
            description: 'Please answer Yes if you need an interpreter or signer to assist you at the hearing. You will then be asked about what language/dialect or type of sign language interpreter you require. We will arrange for a professional interpreter to be present at your hearing if you need one.'
          },
          {
            type: 'section',
            condition: 'model["Check_Box43"] === "Yes"',
            items: [
              {
                type: "section",
                htmlClass: "row",
                items: [
                  {
                    type: "section",
                    htmlClass: "col-xs-6 col-md-5",
                    items: [{
                      key: "Text44",
                      title: "Language or type of sign language interpreter"
                    }]
                  },
                  {
                    type: "section",
                    htmlClass: "col-xs-6 col-md-5",
                    items: [{
                      key: "Text45",
                      title: "Dialect"
                    }]
                  }
                ]
              }
            ]
          },
          {
            key: 'Check_Box46',
            condition: 'model["Check_Box38"] !== "no"',
            title: 'Do you agree to receiving less than 14 days’ notice of a hearing?',
            type: 'radios',
            titleMap: [{value: 'no', name: 'No'},
              {value: 'Yes', name: 'Yes'}
            ],
            description: 'We will usually give you at least 14 days’ notice of the date of the hearing. If you agree, we can also give you less than 14 days’ notice. This may allow the hearing to be arranged more quickly if, for example, another hearing is cancelled and yours can replace it at short notice.'
          }
        ]
      },
      {
        type: 'section',
        condition: 'model.page === 8',
        page: 8,
        items: [
          {
            type: 'template',
            htmlClass: 'well',
            templateUrl: "modules/forms/scripts/services/forms/SSCS1/templates/whatToDoNow.html"
          }
        ]
      },
      {
        type: 'section',
        condition: 'areFormNavigationButtonsVisible()',
        htmlClass: 'text-center margin-top15',
        items: [{
          type: 'actions',
          items: [
            {type: 'button', style: 'btn-default', title: 'Previous', onClick: 'prev()'},
            {type: 'button', style: 'btn-primary', title: 'Next', onClick: 'next()'}
          ]
        }]
      }
    ];
    formUI.setForm(form);

    formUI.getHiddenPages = function (model) {
      if (model["Check_Box38"] === "no") {
        return [7];
      } else {
        return [];
      }
    };
    return formUI;
  }]);
